import { apiFetch } from "../client";

export function getSubscriptionPrices() {
  return apiFetch("/subscription/prices/", {
    method: "GET",
  });
}

export function getSubscriptionCouponDiscount({
  refs,
  package_id,
  forest_management_plan_id,
  coupon_code,
}) {
  return apiFetch("/subscription/coupon-discount/", {
    method: "POST",
    body: JSON.stringify({
      refs,
      package_id,
      forest_management_plan_id,
      coupon_code,
    }),
  });
}

export function getSubscriptionCheckout({ refs, coupon_code, extra_data }) {
  return apiFetch("/subscription/checkout/", {
    method: "POST",
    body: JSON.stringify({ refs, coupon_code, extra_data }),
  });
}
